import type { MediaAsset } from '@ghostscreen/contracts';

function isLocalhostUrl(src: string): boolean {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//i.test(src);
}

export type DisplayPreviewSrcInput = {
  kind: 'image' | 'video';
  asset: Pick<MediaAsset, 'previewUrl' | 'playbackUrl'> | undefined;
  /** Published playlist item URL (device-facing), when available. */
  publishedUrl: string | null | undefined;
};

/**
 * Playable/displayable URL for Manage + card playlist previews.
 * Videos never use the JPEG poster (`previewUrl`).
 */
export function resolveDisplayPreviewSrc(input: DisplayPreviewSrcInput): string | null {
  const raw =
    input.kind === 'video'
      ? input.asset?.playbackUrl || input.publishedUrl || null
      : input.asset?.previewUrl || input.publishedUrl || null;
  if (!raw || isLocalhostUrl(raw)) return null;
  return raw;
}
